export default __webpack_public_path__ + "static/img-finish-products-bbfc222c5854992716d6d1dc51846953.webp";